import React from 'react';
import { FormControl, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <FormControl
      style={{
        minWidth: 100,
        borderColor: '#FFF',
        position: 'relative',
        display: 'flex',
        alignItens: 'center',
        justifyContent: 'center',
        right: '8px',
      }}
      variant="outlined"
    >
      <Select
        native
        value={i18n.language.replace('-', '_') === 'es' ? 'es' : 'pt_BR'}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        inputProps={{
          style: {
            borderRadius: 4,
            position: 'relative',
            border: '2px solid #FFF',
            fontSize: 14,
            padding: '10px 0px 10px 12px',
            fontWeight: 600,
          },
        }}
        style={{ color: '#FFF' }}
      >
        {/* <option style={{ backgroundColor: "#6e3296" }}>IDIOMA</option> */}
        <option value="pt_BR" style={{ backgroundColor: '#6e3296' }}>
          PT-BR
        </option>
        <option value="es" style={{ backgroundColor: '#6e3296' }}>
          ES
        </option>
      </Select>
    </FormControl>
  );
}
